import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LabelValue } from 'app/models/labelvalue';

@Component({
  selector: 'app-pricing-calendar',
  templateUrl: './pricing-calendar.component.html',
  styleUrls: ['./pricing-calendar.component.css']
})
export class PricingCalendarComponent implements OnInit {

  dayTermRentMap: Map<string, number> = new Map;
  desiredMoveInDate: Date;
  leaseTerm: number;
  leaseTermOptions: LabelValue[];
  renderCalendar: boolean = false;
  onDateSelect = new EventEmitter();
  selectedMoveInDate : Date;

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<PricingCalendarComponent>) {

    if (data.desiredMoveInDate && data.leaseTerm) {
      this.leaseTerm = data.leaseTerm;
      this.desiredMoveInDate = data.desiredMoveInDate;
    }

    this.dayTermRentMap = data.dayTermRentMap;
    this.leaseTermOptions = data.leaseTermOptions;
    this.renderCalendar = true;
  }

  ngOnInit(): void {
  }

  hasRentRates(date: Date) {
    let hashKey = `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}-${this.leaseTerm}`;
    return this.dayTermRentMap.get(hashKey);
  }

  getRentRates(date: Date) {
    let hashKey = `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}-${this.leaseTerm}`;

    if (this.dayTermRentMap.has(hashKey)) {
      return this.dayTermRentMap.get(hashKey);
    }
  }

  selectMoveInDate(date: Date) {
    
    this.selectedMoveInDate = date; 
    
    let hashKey = `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}-${this.leaseTerm}`;

    if (this.dayTermRentMap.has(hashKey)) {
      this.desiredMoveInDate = date;
    }
  }

  handleSelectClick() {
    if(this.selectedMoveInDate != null) {
      let hashKey = `${this.selectedMoveInDate.getUTCFullYear()}-${this.selectedMoveInDate.getUTCMonth()}-${this.selectedMoveInDate.getUTCDate()}-${this.leaseTerm}`;

      if (this.dayTermRentMap.has(hashKey)) {
        this.desiredMoveInDate = this.selectedMoveInDate;
        this.onDateSelect.emit([this.selectedMoveInDate.getTime(), this.leaseTerm, this.dayTermRentMap.get(hashKey)]);
      }
    }
    this.dialogRef.close();
  }

  handleCancelClick() {
    this.desiredMoveInDate = null;
    this.dialogRef.close();
  }

}
